import React, { createContext, useEffect, useState } from 'react'
import { addNotification } from './Notifications/Addnotifications';
import { Fire } from './Fire';

export const ContextApp = createContext()
    const ContextAppProvider = ({ children }) => {
    const [user, setUser] = useState('')
    const [firebaseLoaded, setFirebaseLoaded] = useState(false)
    const addNoti = (icon, msg, img) => {
      addNotification({ msg, icon, img });
    };
    useEffect(() => {
      const unsubscribe = Fire.auth().onAuthStateChanged((user) => {
        if (user) {
          setUser(user);
        } else {
          setUser('');
        }
        setFirebaseLoaded(true);
      });
      return () => unsubscribe();
    }, [])

  return <ContextApp.Provider 
           value={{
             addNoti,
             firebaseLoaded, user
             }}>
      {children}
  </ContextApp.Provider>
}
export default ContextAppProvider